import { useState, useCallback } from 'react';
import { RowSelectionState } from '@tanstack/react-table';
import { ProductPriceListItem } from 'features/products/types/productPriceListTypes';

export const useRowSelection = (priceListData: ProductPriceListItem[]) => {
  const [rowSelection, setRowSelection] = useState<RowSelectionState>({});
  const [selectedRowData, setSelectedRowData] = useState<ProductPriceListItem | null>(null);
  
  const getSelectedRow = useCallback(() => {
    const selectedRowIds = Object.keys(rowSelection).filter(key => rowSelection[key]);
    if (selectedRowIds.length === 0) return null;
    
    const selectedRowId = selectedRowIds[0]; // Only one row can be selected
    return (priceListData || []).find((row: any) =>
      row.rowId?.toString() === selectedRowId || row.priceListId?.toString() === selectedRowId
    );
  }, [rowSelection, priceListData]);
  
  const handleRowSelect = useCallback((row: any) => {
    const rowData = row.original as ProductPriceListItem;
    setSelectedRowData(rowData);
    setRowSelection({ [row.id]: true });
  }, []);
  
  const clearSelection = useCallback(() => {
    setRowSelection({});
    setSelectedRowData(null);
  }, []);
  
  const hasSelectedRow = Object.keys(rowSelection).length > 0;
  
  return {
    rowSelection,
    selectedRowData,
    hasSelectedRow,
    getSelectedRow,
    handleRowSelect,
    clearSelection,
    setRowSelection
  };
};
